import React from 'react';
import { Info, Ruler } from 'lucide-react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { InfoBox } from '../InfoBox';
import { FormButtons } from '../FormButtons';
export const TuinbestratingDetailsStep: React.FC = () => {
  const {
    formData,
    handleChange,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  return <FormStep title="Tuinbestrating details" description="Geef de afmetingen van het te bestraten oppervlak aan." isActive={true} data-id="element-1261">
      <div className="space-y-6 mb-10" data-id="element-1262">
        <div data-id="element-1263">
          <label className="block text-white/90 font-medium mb-2" data-id="element-1264">
            Lengte (cm) *
          </label>
          <div className="relative" data-id="element-1265">
            <input type="text" inputMode="numeric" value={formData.tuinbestratingLength} onChange={handleChange} name="tuinbestratingLength" placeholder="Bijv. 500" className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-1266" />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1267">
              <Ruler className="h-5 w-5 text-white/50" data-id="element-1268" />
            </div>
          </div>
        </div>
        <div data-id="element-1269">
          <label className="block text-white/90 font-medium mb-2" data-id="element-1270">
            Breedte (cm) *
          </label>
          <div className="relative" data-id="element-1271">
            <input type="text" inputMode="numeric" value={formData.tuinbestratingWidth} onChange={handleChange} name="tuinbestratingWidth" placeholder="Bijv. 300" className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-1272" />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1273">
              <Ruler className="h-5 w-5 text-white/50" data-id="element-1274" />
            </div>
          </div>
        </div>
        <div data-id="element-1275">
          <label className="block text-white/90 font-medium mb-2" data-id="element-1276">
            Extra opmerkingen (optioneel)
          </label>
          <textarea value={formData.tuinbestratingRemarks} onChange={handleChange} name="tuinbestratingRemarks" rows={3} placeholder="Bijv. type bestrating, speciale wensen, etc." className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-1277" />
        </div>
      </div>
      <InfoBox icon={<Info data-id="element-1279" />} data-id="element-1278">
        Verdere details over materialen, patroon en afwerking zullen telefonisch
        met u worden besproken.
      </InfoBox>
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={!formData.tuinbestratingLength || !formData.tuinbestratingWidth} data-id="element-1280" />
    </FormStep>;
};